@if(!HideHeader)
{
  <h3>Absetzung</h3>
}

<DataGridView [SelectedChanged]="SelectedChanged" [DataUrl]="dataurl()" #Grid KeyProperty="key" [UseUrlFilter]="!DisableUrlFilter">
  <DataGridViewColumn field="key" header="ID" [DataType]="Types.Number" />
  <DataGridViewColumn field="laufID" header="Lauf" [DataType]="Types.Number" />
  <DataGridViewColumn field="year" header="Jahr" [DataType]="Types.Number"  />
  <DataGridViewColumn field="month" header="Monat" [DataType]="Types.Number" />
  <DataGridViewColumn field="status" header="Status" [DataType]="Types.Number" [pipe]="absetzungsStatusPipe" [DataFilterList]="FilterList" />
  <DataGridViewColumn field="firstName" header="Vorname" [DataType]="Types.String" />
  <DataGridViewColumn field="freitext_A" header="Freitext A" [DataType]="Types.String" />
  <DataGridViewColumn field="firstName" header="Vorname" [DataType]="Types.String" />
  <DataGridViewColumn field="lastName" header="Nachname" [DataType]="Types.String" />
  <DataGridViewColumn field="kassenName" header="Kasse" [DataType]="Types.String" />
  <DataGridViewColumn field="partner" header="Partne" [DataType]="Types.String" />



  <DataGridViewColumn  [isFixed]="true" [AllowOrder]="false" [AllowSearch]="false" *ngIf="!DisableUrlFilter" field="key">
    <ng-template #cell let-row>
      <div class="p-1">
        <div class="btn btn-primary btn-sm bi bi-pencil-fill" style="Background:Orange;Border-color:Orange;" (click)="OpenAbsetzung(row)"></div>
        <div class="btn btn-primary btn-sm bi bi-currency-dollar ms-1" style="Background:Green;Border-color:Green;" (click)="SetPayed(row.key)"></div>

        <div class="btn btn-primary btn-sm  bi bi-bag-x-fill  ms-1" style="Background:Yellow;Border-color:Yellow;color:Gray" (click)="SetResubmitCode(row.key)"></div>
        <div class="btn btn-primary btn-sm bi bi-eyeglasses ms-1 " style="Background:Gray;Border-color:Gray;" (click)="OpenAkten(row.versicherungsnummer,row.auftrag)"></div>
      </div>
    </ng-template>
    <ng-template #header>

    </ng-template>
  </DataGridViewColumn>

</DataGridView>

<floatingButton icon="fa-solid fa-person-digging" title="Abrechnung Anlegen" (btnClick)="setWorkInProgress()"></floatingButton>
<ng-template #successVerTpl> Aktion erfolgreich! </ng-template>
<ng-template #FaildVerTpl> Aktion fehlgeschlagen! </ng-template>
